// extracted by mini-css-extract-plugin
export default {"root":"PlaceholderRow-root_KBLQZ","provided":"PlaceholderRow-provided_Xy7JV"};